import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Switch } from "@/components/ui/switch";
import { ConfirmDelete, Field } from "./common";
import { api, formatApiError } from "@/lib/api";

const TYPES = { singleInstance: "Événement simple", occurrence: "Occurrence d'une série", exception: "Exception d'une série" };

export const ExternalEventDialog = ({ event, onOpenChange, onSaved }) => {
  const [f, setF] = useState({});
  const [del, setDel] = useState(false);
  useEffect(() => { if (event) setF({ ...event }); }, [event]);
  const set = (k) => (e) => setF((p) => ({ ...p, [k]: e?.target ? e.target.value : e }));
  const save = async () => {
    try {
      await api.patch(`/outlook/events/${event.id}`, { subject: f.subject, start: f.start, end: f.end, location: f.location || "", is_all_day: !!f.is_all_day });
      toast.success("Événement Outlook modifié");
      onOpenChange(false);
      onSaved();
    } catch (e) {
      toast.error(formatApiError(e));
    }
  };
  const remove = async () => {
    try {
      await api.delete(`/outlook/events/${event.id}`);
      toast.success("Événement supprimé d'Outlook");
      setDel(false);
      onOpenChange(false);
      onSaved();
    } catch (e) {
      toast.error(formatApiError(e));
    }
  };
  const type = f.is_all_day ? "date" : "datetime-local";
  return (
    <Dialog open={!!event} onOpenChange={onOpenChange}>
      <DialogContent data-testid="external-event-dialog" className="bg-[#0F1F3D] border-cyan-400/20 sm:max-w-lg">
        <DialogHeader>
          <DialogTitle className="font-display text-xl">Événement Outlook externe</DialogTitle>
          <DialogDescription className="text-slate-400">{TYPES[event?.type] || "Événement"} · non lié à une intervention{event?.is_organizer === false ? " · invitation reçue (modification peut être refusée)" : ""}</DialogDescription>
        </DialogHeader>
        <div className="grid gap-3">
          <Field label="Titre"><Input value={f.subject || ""} onChange={set("subject")} data-testid="external-event-subject-input" /></Field>
          <label className="flex items-center gap-2 text-sm text-slate-200"><Switch checked={!!f.is_all_day} onCheckedChange={set("is_all_day")} data-testid="external-event-allday-switch" />Journée entière</label>
          <div className={f.is_all_day ? "grid grid-cols-2 gap-3" : "grid gap-3"}>
            <Field label="Début"><Input type={type} value={(f.start || "").slice(0, f.is_all_day ? 10 : 16)} onChange={set("start")} data-testid="external-event-start-input" /></Field>
            <Field label="Fin"><Input type={type} value={(f.end || "").slice(0, f.is_all_day ? 10 : 16)} onChange={set("end")} data-testid="external-event-end-input" /></Field>
          </div>
          <Field label="Lieu"><Input value={f.location || ""} onChange={set("location")} data-testid="external-event-location-input" /></Field>
          {f.body_preview && <p className="max-h-24 overflow-y-auto text-xs text-slate-400">{f.body_preview}</p>}
        </div>
        <div className="flex justify-between gap-2">
          <Button variant="ghost" className="text-red-300" onClick={() => setDel(true)} data-testid="external-event-delete-button">Supprimer</Button>
          <Button onClick={save} className="dt-glow" data-testid="external-event-save-button">Enregistrer dans Outlook</Button>
        </div>
        <ConfirmDelete open={del} onOpenChange={setDel} label="cet événement de votre calendrier Outlook" description="L'événement sera supprimé de votre calendrier Outlook principal." onConfirm={remove} />
      </DialogContent>
    </Dialog>
  );
};
